import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import List from './List';
import Add from './Add';
import Detail from './Detail';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';

export const appPackageRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_PACKAGE.LIST],
    element: (
      <AllowedAccess
        isPageFailed
        permissionIds={[AuthorizePermission.APP_PACKAGE_READ]}
      >
        <List />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_PACKAGE.ADD],
    element: (
      <AllowedAccess
        isPageFailed
        permissionIds={[AuthorizePermission.APP_PACKAGE_CREATE]}
      >
        <Add />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.APP_PACKAGE.VIEW],
    element: (
      <AllowedAccess
        isPageFailed
        permissionIds={[AuthorizePermission.APP_PACKAGE_READ]}
      >
        <Detail />
      </AllowedAccess>
    ),
  },
];
